class FDFilterUI extends HTMLElement {
  connectedCallback() {
    if (this.bound) return;
    this.bound = true;
    this.addEventListener('click', (event) => {
      const opener = event.target.closest('[data-filter-open]');
      if (opener) this.open(opener);
      if (event.target.closest('[data-filter-close]')) this.cancel();
      if (event.target.closest('[data-filter-reset]')) {
        this.querySelectorAll('[data-filter-group]:not([hidden]) input').forEach((input) => {
          if (input.type === 'checkbox') input.checked = false;
          else input.value = '';
          input.dispatchEvent(new Event('input', { bubbles: true }));
        });
      }
      const dialog = this.querySelector('dialog');
      if (event.target === dialog) {
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.cancel();
      }
    });
    this.addEventListener('cancel', (event) => { event.preventDefault(); this.cancel(); }, true);
    this.addEventListener('input', (event) => {
      const input = event.target;
      if (input.matches('[data-filter-search]')) {
        const group = input.closest('[data-filter-group]');
        const query = input.value.trim().toLocaleLowerCase();
        let matches = 0;
        group.querySelectorAll('[data-filter-option]').forEach((option) => {
          option.hidden = !option.textContent.toLocaleLowerCase().includes(query);
          if (!option.hidden) matches += 1;
        });
        group.querySelector('[data-filter-no-match]').hidden = matches > 0;
      }
      if (input.type === 'number') input.setCustomValidity('');
    });
    this.addEventListener('submit', (event) => {
      event.preventDefault();
      const form = this.querySelector('form');
      if (!form.reportValidity()) return;
      const numbers = [...this.querySelectorAll('input[type="number"]')];
      if (numbers.length === 2 && numbers.every((input) => input.value !== '') && Number(numbers[0].value) > Number(numbers[1].value)) {
        const first = numbers[0].value;
        numbers[0].value = numbers[1].value;
        numbers[1].value = first;
      }
      this.close();
      const parent = this.closest('filters-form');
      if (typeof parent?.onFormSubmit === 'function') parent.onFormSubmit(event);
      else form.submit();
    });
  }
  open(button) {
    const dialog = this.querySelector('dialog');
    if (!dialog) return;
    this.opener = button;
    this.saved = [...dialog.querySelectorAll('input')].map((input) => ({ input, value: input.value, checked: input.checked }));
    const key = button.dataset.filterOpen;
    this.querySelectorAll('[data-filter-group]').forEach((group) => { group.hidden = key !== 'all' && group.dataset.filterGroup !== key; });
    dialog.dataset.single = String(key !== 'all');
    const title = dialog.querySelector('[data-filter-title]');
    title.textContent = key === 'all' ? title.dataset.allLabel : button.querySelector('span').textContent;
    button.setAttribute('aria-expanded', 'true');
    dialog.showModal();
    dialog.querySelector('.fd-filters__body').scrollTop = 0;
    dialog.querySelector('[data-filter-close]').focus({ preventScroll: true });
  }
  cancel() {
    this.saved?.forEach(({ input, value, checked }) => { input.value = value; input.checked = checked; });
    this.close();
  }
  close() {
    const dialog = this.querySelector('dialog');
    dialog?.close();
    this.querySelectorAll('[data-filter-open]').forEach((button) => button.setAttribute('aria-expanded', 'false'));
    this.querySelectorAll('[data-filter-search]').forEach((input) => { input.value = ''; input.dispatchEvent(new Event('input', { bubbles: true })); });
    this.opener?.focus({ preventScroll: true });
    this.saved = null;
  }
}
if (!customElements.get('fd-filter-ui')) customElements.define('fd-filter-ui', FDFilterUI);
